// The realtime wire protocol. Plain JSON over a native WebSocket — Socket.IO
// cannot run on Workers, and a discriminated union keeps both ends honest.

import type { Pack } from "./pack";
import type { Fx, GameStateView, Language } from "./types";

export type ClientMsg =
  // ---- player ----
  | { t: "player:join"; name: string; avatarUrl: string }
  | { t: "player:rejoin"; playerId: string }
  | { t: "player:buzz" }
  | { t: "player:wager"; amount: number }
  | { t: "player:answer"; text: string }
  // ---- host (only honoured on a socket that authenticated with the room token) ----
  | { t: "host:reveal"; categoryId: string; points: number }
  | { t: "host:openBuzzers" }
  | { t: "host:closeBuzzers" }
  | { t: "host:resetBuzzers" }
  | { t: "host:judge"; playerId: string; correct: boolean }
  | { t: "host:revealAnswer" }
  | { t: "host:backToBoard" }
  | { t: "host:adjustScore"; playerId: string; delta: number }
  | { t: "host:setScore"; playerId: string; score: number }
  | { t: "host:kick"; playerId: string }
  | { t: "host:forceIntermission" }
  | { t: "host:nextRound" }
  | { t: "host:goToRound"; roundIndex: number }
  | { t: "host:resetGame" }
  | { t: "host:toFinal" }
  | { t: "host:wagerShowQuestion" }
  | { t: "host:wagerReveal" }
  | { t: "host:wagerJudge"; playerId: string; correct: boolean }
  | { t: "host:setTheme"; theme: string }
  | { t: "host:setLanguage"; language: Language }
  | { t: "host:setPack"; pack: Pack }
  // ---- keepalive ----
  | { t: "ping" };

export type ServerMsg =
  | { t: "state"; state: GameStateView }
  | { t: "fx"; fx: Fx }
  | { t: "joined"; playerId: string }
  | { t: "rejoinFailed" }
  | { t: "error"; code: "auth" | "notFound" | "rateLimit" | "badPack"; message: string }
  | { t: "pong" };

/** Close codes the client reacts to specifically (4000+ is the app-defined range). */
export const CLOSE = {
  ROOM_NOT_FOUND: 4004,
  BAD_TOKEN: 4003,
  ROOM_FULL: 4008,
  ROOM_DELETED: 4010,
} as const;
